import { render } from "./VCalendar.vue?vue&type=template&id=2263e71e"
import script from "./VCalendar.vue?vue&type=script&lang=js"
export * from "./VCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__